// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any)['__zone_symbol__PASSIVE_EVENTS'] = ['wheel'];
